import React, { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/scss/style.scss";
import { getPrimaryShopId } from "./helpers/shop";
import { getShopInfo } from "./slices/ShopInfo/thunk";
import { registerWebPushSubscription } from "./helpers/pushNotifications";
import type { AppDispatch } from "./store";
import Route from "./routes";

function App() {
    const dispatch = useDispatch<AppDispatch>();
    const authUser = useSelector((state: any) => state.auth.user);
    const shop = useSelector((state: any) => state.ShopInfo.shop);
    const shopId = useMemo(() => getPrimaryShopId(authUser), [authUser]);

    useEffect(() => {
        if (authUser && shopId && !shop) {
            dispatch(getShopInfo(shopId));
        }
    }, [authUser, dispatch, shopId, shop]);

    /**
     * Khi user đã cài PWA trước đó, sau này frontend được update thêm
     * REACT_APP_VAPID_PUBLIC_KEY, user chỉ cần bấm "Tải lại".
     *
     * Sau khi reload sang bundle mới:
     * - Nếu Notification.permission đã là "granted" thì tự đăng ký web push.
     * - Nếu permission vẫn là "default" thì user vẫn cần bấm nút "Bật thông báo"
     *   ở trang Settings/Notifications.
     */
    useEffect(() => {
        if (!authUser) {
            return;
        }

        if (typeof window === "undefined" || !("Notification" in window)) {
            return;
        }

        if (Notification.permission !== "granted") {
            return;
        }

        void registerWebPushSubscription();
    }, [authUser]);

    const toneColor = authUser ? shop?.tone_color ?? shop?.toneColor ?? "#2563EB" : "#2563EB";

    useEffect(() => {
        if (typeof document !== "undefined") {
            document.documentElement.style.setProperty("--tone-color", toneColor);
        }
    }, [toneColor]);

    return (
        <React.Fragment>
            <Route />
        </React.Fragment>
    );
}

export default App;